const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}



/** mt-image-selector **/
Array.from(document.querySelectorAll(".mt-image-selector__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-selector__selector");
    var itemSelects = Array.from(container.querySelectorAll(".mt-image-selector__item"));
  
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.remove("unshow");
          }else{
            item.classList.add("unshow");
          }     
        });
      });
    });
});
/** mt-image-selector **/

/** mt-text-selector **/
Array.from(document.querySelectorAll(".mt-text-selector__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-text-selector__selector");
    var itemSelects = Array.from(container.querySelectorAll(".mt-text-selector__item"));
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.remove("hidden");
            item.classList.remove("unshow");
          }else{
            item.classList.add("hidden");
            item.classList.add("unshow");
          }     
        });
      });
    });
});
/** mt-text-selector **/

/** mt-image-text-icons **/
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-text-icons__dot");
    var itemSelects = Array.from(container.querySelectorAll(".mt-image-text-icons__image"));
  
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.add("blur_show");
          }else{
            item.classList.remove("blur_show");
          }     
        });
      });
    });
});
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach((container) => {
    var selectors = container.querySelectorAll(".mt-image-text-icons__icon-item");
    selectors.forEach((selector) => {
      selector.addEventListener('click', (e) => {
        selectors.forEach((item) => {
          item.querySelector(".mt-image-text-icons__arrow").classList.remove("selected");
        });
        selector.querySelector(".mt-image-text-icons__arrow").classList.add("selected");
        var val = parseInt(selector.querySelector(".mt-image-text-icons__arrow").getAttribute("data-val"));
        Array.from(container.querySelectorAll(".mt-image-text-icons__icon-detail")).forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if(val == curVal){
            item.classList.toggle("scale0");
          }else{   
            item.classList.add("scale0");
          }     
        });
      });
    });
});
/** mt-image-text-icons **/

/** mt-video-list **/
Array.from(document.querySelectorAll(".mt-video-list_container")).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    let isClicked = false;
    let maxWidth = container.querySelector(".mt-video-list-wrapper").getBoundingClientRect().left + container.querySelector(".mt-video-list-wrapper").getBoundingClientRect().width + 200;
    btns.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        if(val > 1){
          val = parseInt(val) - 1;
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    btns.querySelector(".slider-button--next").addEventListener('click', (e) => {
        if(isClicked) return;
        isClicked = true;t
        let val = parseInt(btns.getAttribute("data-val"));
        let maxVal = parseInt(btns.getAttribute("data-max-val"));
        let width = itemSelects[itemSelects.length -1].getBoundingClientRect().width + itemSelects[itemSelects.length -1].getBoundingClientRect().left;
        if(val < maxVal && width > maxWidth){
          val = val + 1;
          console.log("max-width:" + maxWidth + ", width:" + width + ", item_width:" + itemSelects[itemSelects.length -1].getBoundingClientRect().width + ", item_left:" + itemSelects[itemSelects.length -1].getBoundingClientRect().left);
          selectContent(val);
        }else{
          isClicked = false;
        }
    });
    let itemSelects = Array.from(container.querySelectorAll(".mt-video-list-item"));
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
    function selectContent(val){ 
      let moveX = 0;
      if(itemSelects != null && itemSelects.length > 1){
        moveX = firstLeft - leftX * (val - 1);
      }
      itemSelects.forEach((itemItem) => {
        container.querySelector(".mt-video-list-wrapper").style.marginLeft = moveX + "px";
        console.log("leftX:" + leftX + ",val:" + val);
      });
      btns.setAttribute("data-val", val);
      isClicked = false;
    }
});
/** mt-video-list **/

/** mt-reviews-tabs 
Array.from(document.querySelectorAll(".mt-reviews-tabs__container")).forEach((container) => {
  let dots = container.querySelector(".mt-reviews-tabs__dots");
  let itemSelects = Array.from(container.querySelectorAll(".mt-reviews-tabs__item"));
  if(dots != null && itemSelects != null){
     Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
       dot.addEventListener('click', (e) => {  
         let val = parseInt(e.target.getAttribute("data-val"));
         selectContent(parseInt(val));
       });
    });
    let times = parseInt(container.querySelector(".mt_interval_times").innerText);
    let maxVal = parseInt(dots.getAttribute("max-val"));

    let firstLeft = container.querySelector(".mt_interval_times").offsetLeft; 
    let leftX  = 0;
    if(itemSelects.length > 1){
      leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
      if(window.innerWidth >= 750){
        selectContent(1);
      }
    }
    if(window.innerWidth < 750){
      selectContent(1);
    }
    itemSelects.forEach((slider) => {
      slider.addEventListener('touchstart', function(e) {
        startX = e.touches[0].pageX;
      });
      slider.addEventListener('touchmove', function(e) {
        e.preventDefault();
      });
      slider.addEventListener('touchend', function(e) {
        let val = parseInt(e.target.getAttribute("data-val"));
        endX = e.changedTouches[0].pageX;
        if (endX - startX > 0) {
           const count = val > 0? val - 1: 0;
           selectContent(count);
        } else {
           const count = val < maxVal ? val + 1: maxVal;
           selectContent(count);
        }
      });     
    });
    var valCount = parseInt(container.querySelector(".mt-reviews-tabs__items").offsetWidth / container.querySelector(".mt-reviews-tabs__item").offsetWidth);

    function selectContent(val){
      let moveX = 0;
      if(itemSelects != null && itemSelects.length > 1){
        if(window.innerWidth < 750){
          moveX = firstLeft - leftX * (val -1)
        }else{     
          moveX = firstLeft - leftX * (val - valCount);
        }
      }
      if(moveX > 0){
        moveX = 0;
      }
      container.querySelector(".mt-reviews-tabs__items").style.marginLeft = moveX + "px";
      Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
        if(parseInt(item.getAttribute("data-val")) == val){
          item.classList.add("selected");
        }else{
          item.classList.remove("selected");
        }
      });
      Array.from(itemSelects).forEach((item) => {
        if(parseInt(item.getAttribute("data-val")) == val){
          item.classList.add("selected");
        }else{
          item.classList.remove("selected");
        }
      });
      curIndex = val;
    }
  }

});
 mt-reviews-tabs **/

/** mt-showcase-products **/
Array.from(document.querySelectorAll(".mt-showcase-products__container")).forEach((container) => {
  let points = container.querySelectorAll(".mt-showcase-products__pointer");
  let rblogs = container.querySelectorAll(".mt-showcase-products__rblog");
  points.forEach((point) => {
    point.addEventListener('click', (e) => {
      points.forEach((item) => {
        item.classList.remove("selected");
      });
      point.classList.add("selected");
      rblogs.forEach((item) => {
        if(item.getAttribute("data-val") == point.getAttribute("data-val")){
          item.classList.add("selected");
        }else{
          item.classList.remove("selected");
        }
      });
    });
  });
  rblogs.forEach((rblog) => {
    rblog.addEventListener('mouseover', (e) => {
      rblogs.forEach((item) => {
        item.classList.remove("selected");
      });
      rblog.classList.add("selected");
      points.forEach((item) => {
        if(item.getAttribute("data-val") == rblog.getAttribute("data-val")){
          item.classList.add("selected");
        }else{
          item.classList.remove("selected");
        }
      });
    });
  });
});
/** mt-showcase-products **/

/** mt-slideshow **/
Array.from(document.querySelectorAll(".mt-slideshow__container")).forEach((container) => {
  let dots = container.querySelector(".mt-slideshow__dots");
  let itemSelects = Array.from(container.querySelectorAll(".mt-slideshow__item"));
  if(dots != null && itemSelects != null){
     Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
       dot.addEventListener('click', (e) => {  
         let val = parseInt(e.target.getAttribute("data-val"));
         selectContent(parseInt(val));
       });
    });
    let times = parseInt(container.querySelector(".mt_interval_times").innerText);
    let maxVal = parseInt(dots.getAttribute("max-val"));
    let curIndex = 1;
    // 自动轮播
    setInterval(function() {
      if(curIndex < maxVal){
        curIndex++;
      }else{
        curIndex = 1;
      }
      selectContent(curIndex);
    }, times * 1000); 
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX  = 0;
    if(itemSelects.length > 1){
      leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
    }
    function selectContent(val){
      let moveX = 0;
      if(itemSelects != null && itemSelects.length > 1){
        moveX = firstLeft - leftX * (val - 1);
      }
      container.querySelector(".mt-slideshow__items").style.marginLeft = moveX + "px";
      Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
        if(parseInt(item.getAttribute("data-val")) == val){
          item.classList.add("selected");
        }else{
          item.classList.remove("selected");
        }
      });
      curIndex = val;
    }    
  }

});
/** mt-slideshow **/

/** mt-image-videos **/
Array.from(document.querySelectorAll(".mt-image-videos__container")).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    let list = container.querySelector(".mt-image-videos__list.pc_show");
    if(window.innerWidth < 768){
      list = container.querySelector(".mt-image-videos__list.mb_show");
    }
    let itemSelects = Array.from(list.querySelectorAll(".mt-image-videos__item"));
    let maxLeft = container.querySelector(".mt-image-videos__wrapper").offsetWidth;
    itemSelects.forEach((item) => {
      maxLeft = maxLeft - item.offsetWidth - 20;
    });
    let m = itemSelects[1].offsetLeft;  

    btns.querySelector(".slider-button--prev").addEventListener('click', (e) => {
      selectContent(-1);
    });
    btns.querySelector(".slider-button--next").addEventListener('click', (e) => {
        selectContent(1);
    });
    function selectContent(val){ 
      let moveX = 0; 
      if(itemSelects != null && itemSelects.length > 1){
        moveX = list.offsetLeft - m * val;
      }
      if(moveX < maxLeft){
        moveX = maxLeft;
      }
      if(moveX > 0){
        moveX = 0;
      }
      if(list.offsetLeft != moveX){       
        list.style.marginLeft = moveX + "px";
      }     
    }


    let videos = Array.from(container.querySelectorAll(".mt-image-videos__video"));
    videos.forEach((video) => {
      video.addEventListener('click', (e) => {
        videos.forEach((item) => {
          if(item != video){
            item.querySelector("video").pause();
          }
        });
      });
    });
});
/** mt-image-videos **/


/** mt-showcase-blogs **/
Array.from(document.querySelectorAll(".mt-showcase-blogs__container")).forEach((container) => {
    let btns = container.querySelector(".slider-buttons");
    let list = container.querySelector(".mt-showcase-blogs__blogs");
    let itemSelects = Array.from(list.querySelectorAll(".mt-showcase-blogs__blog"));
    let maxLeft = container.querySelector(".mt-showcase-blogs__wrapper").offsetWidth;
    itemSelects.forEach((item) => {
      maxLeft = maxLeft - item.offsetWidth - 20;
    });
    let m = itemSelects[1].offsetLeft;  

    btns.querySelector(".slider-button--prev").addEventListener('click', (e) => {
      selectContent(-1);
    });
    btns.querySelector(".slider-button--next").addEventListener('click', (e) => {
        selectContent(1);
    }); 
    function selectContent(val){ 
      let moveX = 0; 
      if(itemSelects != null && itemSelects.length > 1){
        moveX = list.offsetLeft - m * val;
      }
      if(moveX < maxLeft){
        moveX = maxLeft;
      }
      if(moveX > 0){
        moveX = 0;
      }
      if(list.offsetLeft != moveX){       
        list.style.marginLeft = moveX + "px";
      }  
    }
});
/** mt-showcase-blogs **/



/** footer **/
Array.from(document.querySelectorAll(".footer__blocks-wrapper")).forEach((container) => {
  container.querySelectorAll(".footer-block__heading_down").forEach((btn) => {
    btn.addEventListener('click', (e) => {
      var cont = null;
      Array.from(btn.parentElement.parentElement.children).forEach((item) => {
        if(item.classList.contains("footer-block__details-content") && item.classList.contains("mb_show")){
          cont = item;
        }
      });
      if(btn.textContent == "-"){
        btn.textContent = "+";
        cont.classList.add("scale0");
      }else{
        btn.textContent = "-";
        cont.classList.remove("scale0");      
      }
    });
  });
});


/** footer **/